import {makeAsyncAction} from 'common/utils/simplifiedAsync';

const ACTION_PREFIX = 'anodot/admin.csPortal/';
const macAsync = (actionName) => makeAsyncAction(actionName, ACTION_PREFIX);

export const sendMail = macAsync('SEND_MAIL');
export const getChampions = macAsync('GET_CHAMPIONS');
